<template>
    <hts-form-select
        v-model="cValue"
        :label="label"
        :items="types"
        key-id="value"
        key-label="title"
        :prop="prop"
        :name="name" />
</template>
<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  required: { type: Boolean },
  prop: { type: String },
  label: { type: String },
  name: { type: String }
})

const { modelValue } = toRefs(props)

const emits = defineEmits(['update:modelValue'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const types = ref([
  {
    value: 'mobile_app',
    title: 'Mobile App'
  },
  {
    value: 'eup',
    title: 'EUP'
  },
  {
    value: 'binhanh',
    title: 'Binh Anh'
  }
])
</script>
